import { Box, Button } from "@mui/material"
import { useEffect } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { AcceptedChanged } from "event-definitions"
import { infoSnackbar } from "lib/snackbar/info-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { PAYLOAD_STATUS_APPROVED } from "routes/audit/lib/audit-constants.mjs"
import { useReviewDecisions } from "./review-decisions"

export function InlineAcceptButton() {
    const { auditPayload, referenceId, buttonId, userName, accepted, setOptimisticDecision, uniqueId, ensureAuditId } =
        useBoundContext()
    const decisions = useReviewDecisions()
    const taskId = auditPayload?.taskId

    useEffect(() => {
        AcceptedChanged.raise({ id: buttonId, taskId, accepted, uniqueId })
    }, [uniqueId, accepted, buttonId, taskId])
    return (
        <Box display="flex" alignItems="center">
            <Button
                size="small"
                color="primary"
                variant={!accepted ? "outlined" : undefined}
                startIcon={accepted && <Iconify icon="mdi:check" />}
                onClick={accepted ? showAccepted : accept}
                data-cy={`inline-accept-button-${buttonId}`}
            >
                {accepted ? "Approved" : "Approve"}
            </Button>
        </Box>
    )

    async function accept() {
        const currentAuditId = ensureAuditId()
        const actionedOn = new Date().toISOString()
        auditPayload.shortDescription = "Change Accepted"
        auditPayload.status = PAYLOAD_STATUS_APPROVED
        auditPayload.event = "tailoring!custom-schedule-accept"
        auditPayload.actionedOn = actionedOn
        auditPayload.userName = userName
        auditPayload.reason = ""

        // Optimistic: button + banner reflect this immediately; clear it to revert on failure.
        setOptimisticDecision({ status: PAYLOAD_STATUS_APPROVED, reason: "", userName, actionedOn })
        try {
            await decisions.record({
                auditId: currentAuditId,
                referenceId,
                shortDescription: "Change Accepted",
                payload: auditPayload,
            })
        } catch (e) {
            console.warn("Decision update failed (offline or network error):", e?.message || e)
            setOptimisticDecision(null)
            errorSnackbar("Failed to save approval. Please try again.")
        }
    }
    function showAccepted() {
        return infoSnackbar("Change already approved.")
    }
}
